import { create } from 'zustand';

interface Toast {
  id: number;
  message: string;
  kind: 'success' | 'error' | 'warning';
}

interface UiState {
  sidebarCollapsed: boolean;
  commandPaletteOpen: boolean;
  shortcutsOpen: boolean;
  toasts: Toast[];

  toggleSidebar: () => void;
  setCommandPalette: (open: boolean) => void;
  setShortcuts: (open: boolean) => void;
  toast: (message: string, kind?: Toast['kind']) => void;
  dismissToast: (id: number) => void;
}

export const useUi = create<UiState>((set) => ({
  sidebarCollapsed: false,
  commandPaletteOpen: false,
  shortcutsOpen: false,
  toasts: [],

  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setCommandPalette: (commandPaletteOpen) => set({ commandPaletteOpen }),
  setShortcuts: (shortcutsOpen) => set({ shortcutsOpen }),
  toast: (message, kind = 'success') => {
    const id = Date.now() + Math.random();
    set((s) => ({ toasts: [...s.toasts, { id, message, kind }] }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, 3500);
  },
  dismissToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
